module.exports = __webpack_public_path__ + "img/index_logo.e63c9411.png";